import { CatalogFilters } from "@services/catalog/types";
import _ from "lodash";
import {
  asBoolean,
  asString,
  objectToSearchParams,
  SLFilterToSearch,
} from "./common";
import { getMappedValue } from "./const";

export const widgetFilterToSLFilter = (
  filters: (WidgetFilter | FilterDefinition)[] = []
): CatalogFilters => {
  let mapped: CatalogFilters = {};
  const mapValue = (
    key: string,
    filterValue: string | string[] | undefined
  ) => {
    let value: typeof filterValue;
    switch (typeof filterValue) {
      case "boolean":
        value = filterValue;
        break;
      case "string":
      case "number":
        value = Boolean(filterValue) ? filterValue : undefined;
        break;
      case "object":
        Array.isArray(filterValue) && filterValue.every((v) => Boolean(v))
          ? (value = filterValue)
          : (value = undefined);
      default:
        value = filterValue;
        break;
    }
    return getMappedValue(
      mapped,
      key as keyof CatalogFilters,
      value
    ) as CatalogFilters;
  };

  filters.forEach((f) => {
    switch (f.filterType as FilterTypes) {
      case "deviceType":
        mapped = mapValue(
          "deviceType",
          Array.isArray(f.payload)
            ? f.payload
            : Boolean(f.filterValue)
            ? [f.filterValue]
            : undefined
        );
        break;
      default:
        mapped = mapValue(f.filterType as keyof CatalogFilters, f.filterValue);
        break;
    }
  });
  return mapped;
};

export const widgetFilterToSearchParams = (
  filters?: (WidgetFilter | FilterDefinition)[]
) => {
  const asSL: any = widgetFilterToSLFilter(filters);
  return objectToSearchParams(asSL);
};

const SLFilterToWidgetFilter = (
  slFilters: CatalogFilters
): FilterDefinition[] => {
  const filters: FilterDefinition[] = [];
  //! will be uncommented when the BE has added the “active” filter
  // if (slFilters["active"] !== undefined) {
  //   filters.push({
  //     filterType: "active",
  //     filterValue: slFilters["active"] ? "true" : "false",
  //   });
  // }
  if (slFilters["deviceType"] !== undefined) {
    filters.push({
      filterType: "deviceType",
      filterValue: "",
      payload: slFilters["deviceType"],
    });
  }
  if (slFilters["category"] !== undefined) {
    filters.push({
      filterType: "category",
      filterValue: slFilters["category"],
    });
  }
  if (slFilters["manufacturer"] !== undefined) {
    filters.push({
      filterType: "manufacturer",
      filterValue: slFilters["manufacturer"],
    });
  }
  return filters;
};

const searchToSLFilter = (params: URLSearchParams): CatalogFilters => {
  const filters: CatalogFilters = {};
  const temp = {
    deviceType: params.getAll("deviceType"),
  };

  asString(filters, params, ["category", "manufacturer"]);
  //! will be uncommented when the BE has added the “active” filter
  // asBoolean(filters, params, ["active"]);

  if (temp.deviceType.length > 0) filters.deviceType = temp.deviceType;

  return filters;
};

const searchToWidgetFilter = (params: URLSearchParams): FilterDefinition[] => {
  let definition = SLFilterToWidgetFilter(searchToSLFilter(params));

  return definition;
};

const omitSLFilters = (filters: CatalogFilters) =>
  _.omit(filters, ["watchList"]);

export default {
  fromDefinition: {
    toSL: (filters: (WidgetFilter | FilterDefinition)[] = [], omit = true) => {
      return omit
        ? omitSLFilters(widgetFilterToSLFilter(filters))
        : widgetFilterToSLFilter(filters);
    },
    toSearchParams: widgetFilterToSearchParams,
  },
  fromSL: {
    toDefinition: SLFilterToWidgetFilter,
    toSearchParams: (d: CatalogFilters) => SLFilterToSearch(d),
  },
  fromSearchParams: {
    toSL: (params: URLSearchParams, isOmit: boolean = true) =>
      isOmit
        ? omitSLFilters(searchToSLFilter(params))
        : searchToSLFilter(params),
    toDefinition: searchToWidgetFilter,
  },
};
